import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function DeployWebLoader() {
  const theme = useTheme();

  return (
    <Box p={{ xs: 2, lg: 3 }}>
      {/* Page Title */}
      <Skeleton variant='text' width={200} height={36} sx={{ mb: 3 }} />

      {/* Deploy Agent */}
      <Box bgcolor={theme.palette.background.paper} borderRadius='10px' p={{ xs: 2, lg: 3 }} mb={3}>
        <Skeleton variant='text' width={220} height={28} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={120} sx={{ borderRadius: 1, mb: 2 }} />
        <Skeleton variant='rectangular' width={100} height={36} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Customize Styling */}
      <Box bgcolor={theme.palette.background.paper} borderRadius='10px' p={{ xs: 2, lg: 3 }} mb={3}>
        <Skeleton variant='text' width={200} height={28} sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant='rectangular' width='100%' height={40} sx={{ borderRadius: 1 }} />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Skeleton variant='rectangular' width='100%' height={40} sx={{ borderRadius: 1 }} />
          </Grid>
        </Grid>
      </Box>

      {/* Embed Screen Position */}
      <Box bgcolor={theme.palette.background.paper} borderRadius='10px' p={{ xs: 2, lg: 3 }}>
        <Skeleton variant='text' width={240} height={28} sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {[1, 2, 3].map((idx) => (
            <Grid key={idx} size={{ xs: 12, sm: 4 }}>
              <Skeleton variant='rectangular' width='100%' height={120} sx={{ borderRadius: 1 }} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
